import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=ae0a4e20&scoped=true&"
import script from "./UserDisplay.vue?vue&type=script&lang=js&"
export * from "./UserDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0a4e20",
  null
  
)

export default component.exports